import { Component } from '@angular/core';

@Component({
    selector: 'ifb-user-menu',
    templateUrl: './user-menu.component.html',
    standalone: false
})
export class UserMenuComponent { }
